import { template } from "@ember/template-compiler";
import { registerDestructor } from '@ember/destroyable';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import OnDocumentVisibility from 'client-portal/modifiers/on-document-visibility';
// SPDS Modal pulls in dialog-polyfill, which crashes FastBoot (no HTMLElement).
// Keep that import out of the billing route template's static graph.
export default class SiteBillingTransferSetupModalHost extends Component {
    @service
    billingTransfer;
    @service
    fastboot;
    @tracked
    Modal = null;
    constructor(){
        super(...arguments);
        if (this.fastboot.isFastBoot) {
            return;
        }
        let cancelled1 = false;
        registerDestructor(this, ()=>{
            cancelled1 = true;
        });
        this.#loadModal(()=>cancelled1);
    }
    async #loadModal(isCancelled1) {
        let mod1 = await import('./transfer-setup-modal');
        if (!isCancelled1()) {
            this.Modal = mod1.default;
        }
    }
    static{
        template(`
    {{#if this.billingTransfer.isPendingTransfer}}
      <div
        hidden
        data-test-billing-transfer-visibility-watcher
        {{OnDocumentVisibility this.billingTransfer.onDocumentVisible}}
      ></div>
    {{/if}}

    {{#if this.billingTransfer.isModalOpen}}
      {{#if this.Modal}}
        <this.Modal />
      {{/if}}
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
